module.exports = __webpack_public_path__ + "media/images/background_newsroom-3936586d.jpg";